import * as types from './mutation-types';

export default {
  [types.SET_GENERATE_PRINT](state, generatePrint) {
    state.generatePrint = generatePrint;
  },
  [types.SET_CHECKOUTS](state, payload) {
    state.checkouts = payload;
  },
  [types.POST_CHECKOUT](state, payload) {
    state.checkoutPosted = payload;
  },
  [types.SET_SAT_TRANSMITTER](state, satTransmitter) {
    state.satTransmitter = satTransmitter;
  },
  [types.SET_DISCOUNT](state, discount) {
    state.discount = discount;
  },
  [types.SET_DISCOUNT_ITEM](state, discountItem) {
    state.discountItem = discountItem;
  },
  [types.SET_EXTRA_VALUE](state, extraValue) {
    state.extraValue = extraValue;
  },
  [types.SET_EXTRA_VALUE_ITEM](state, extraValueItem) {
    state.extraValueItem = extraValueItem;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
  [types.SET_MODAL_DISCOUNT_EXTRA_VALUE_ITEM](state) {
    state.modalDiscountExtraValueItem = !state.modalDiscountExtraValueItem;
  },
  [types.GET_TOTAL_NOTA](state, total) {
    state.totalNota = total;
  },
};
